export default __webpack_public_path__ + "bayes-equation5.png";